import { render, staticRenderFns } from "./NewDashboard.vue?vue&type=template&id=57c131b4&scoped=true&"
import script from "./NewDashboard.vue?vue&type=script&lang=ts&"
export * from "./NewDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./NewDashboard.vue?vue&type=style&index=0&id=57c131b4&prod&lang=scss&"
import style1 from "./NewDashboard.vue?vue&type=style&index=1&id=57c131b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c131b4",
  null
  
)

export default component.exports